// src/themes/index.ts
var THEME_TOKENS = {
  cosmos: {
    bgDeep: "#04070d",
    bgMid: "#0a1020",
    accent: "#7eb8ff",
    accentSoft: "rgba(126, 184, 255, 0.35)",
    text: "#e8f0ff",
    muted: "rgba(232, 240, 255, 0.65)",
    effectLine: "#ffb347",
    textLine: "#7eb8ff",
    videoLine: "#ff7eb8",
    soundLine: "#ffb347",
    musicLine: "#ffd747",
    imageLine: "#47ffc4",
    choiceLine: "#f5c455",
    creditsLine: "#c8a0e8"
  },
  wilds: {
    bgDeep: "#0d120c",
    bgMid: "#152018",
    accent: "#7bc96f",
    accentSoft: "rgba(123, 201, 111, 0.35)",
    text: "#eef6ea",
    muted: "rgba(238, 246, 234, 0.7)",
    effectLine: "#b78aff",
    textLine: "#7bc96f",
    videoLine: "#e87bc9",
    soundLine: "#b78aff",
    musicLine: "#d4a0ff",
    imageLine: "#7affb3",
    choiceLine: "#b8e86f",
    creditsLine: "#d4a0ff"
  }
};
var SCENE_TREE_THEMES = {
  cosmos: {
    bg: "#020408",
    edgeChoice: "#e8f0ff",
    edgeGoto: "#4a9fff",
    nodeDefault: "#ffffff",
    nodeActive: "#ffd47e",
    borderDefault: "#3a5080",
    borderActive: "#fff6d0",
    labelDefault: "rgba(220, 232, 255, 0.92)",
    labelActive: "rgba(255, 246, 220, 0.98)",
    nodeLockedFill: "#151a28",
    nodeLockedBorder: "#2a3348",
    labelLocked: "rgba(200, 210, 230, 0.35)",
    nodeShape: "star",
    rectRx: 2
  },
  wilds: {
    bg: "#04070d",
    edgeChoice: "#ffffff",
    edgeGoto: "#6ecf7a",
    nodeDefault: "#e8f5e4",
    nodeActive: "#d31e2f",
    borderDefault: "#2d4a32",
    borderActive: "#ff9ea8",
    labelDefault: "rgba(232, 245, 228, 0.92)",
    labelActive: "rgba(255, 214, 219, 0.98)",
    nodeLockedFill: "#1a221c",
    nodeLockedBorder: "#2a3d30",
    labelLocked: "rgba(200, 220, 200, 0.38)",
    nodeShape: "rect",
    rectRx: 3
  }
};
function getThemeTokens(realmId) {
  return THEME_TOKENS[realmId ?? "wilds"] ?? THEME_TOKENS.wilds;
}
function getSceneTreeTheme(realmId) {
  return SCENE_TREE_THEMES[realmId ?? "wilds"] ?? SCENE_TREE_THEMES.wilds;
}

export { SCENE_TREE_THEMES, THEME_TOKENS, getSceneTreeTheme, getThemeTokens };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map